import fetchPost from '@/api/http.js'

export default {
    actions: {
        getEmployeeListApi({}, data) {
            return fetchPost('/saas/user/queryList', data)
        },
        createEmployeeApi({}, data){
            return fetchPost('/saas/user/addMember', data)
        },
        alterEmployInfoApi({}, data) {
            return fetchPost('/saas/member/updateMember', data)
        },
        enableMemberApi({}, data) {
            return fetchPost('/saas/user/enableMember', data)
        },
        disableMemberApi({}, data) {
            return fetchPost('/saas/user/disableMember', data)
        },
        removeEmployeeApi({},data){
            return fetchPost('/saas/user/deleteMember',data)
        },
        removeEmployeesApi({},data){
            return fetchPost('/saas/user/removeMemList',data)
        },
		queryMultiTenantApi({},data){
		    return fetchPost('/saas/user/queryMultiTenant',data)
		},
        getOrgTreeApi(){
            return fetchPost('/saas/org/queryOrgTree', {})
        },
        getPowerTreeApi(){
            return fetchPost('/saas/org/queryPowerTree', {})
        },
        getOrgQueryMembersApi({},data){
            return fetchPost('/saas/org/queryMembers', data)
        },
        getOrgExMemberApi({},data){
            return fetchPost('/saas/org/queryMembersExclude', data)
        },
        addMemsToOrgApi({},data){
            return fetchPost('/saas/org/addMembers', data)
        },
        createOrgApi({},data){
            return fetchPost('/saas/org/saveOrg', data)
        },
        updateOrgApi({},data){
            return fetchPost('/saas/org/updateOrg', data)
        },
        removeMembersApi({},data){
            return fetchPost('/saas/org/removeMembersBatch', data)
        },
        removeOrgApi({},data){
            return fetchPost('/saas/org/delOrg', data)
        },
        getRoleListApi({},data){
            return fetchPost('/saas/role/roleList', data)
        },
        getRoleListSummaryApi({},data){
            return fetchPost('/saas/role/roleSummary', data)
        },
        createRoleApi({},data){
            return fetchPost('/saas/role/addRole', data)
        },
        deleteRoleApi({},data){
            return fetchPost('/saas/role/deleteRole', data)
        },
        updateRoleApi({},data){
            return fetchPost('/saas/role/updateRole', data)
        },
        queryRoleMemberListApi({},data){
            return fetchPost('/saas/role/queryRoleMemberList', data)
        },
        queryMenuTreeDefaultApi(){
            return fetchPost('/saas/role/queryMenuByTenant', {})
        },
        queryRoleDetailMenuListApi({},roleId){
            return fetchPost('/saas/role/queryMenuList', {roleId:roleId})
        },
        queryRoleDetailMemberListApi({},data){
            return fetchPost('/saas/role/queryRoleMemberList',data)
        },
        updateRoleStateApi({},data){
            return fetchPost('/saas/role/updateRoleState',data)
        },
        
        
		
        getCompanyQualificationInfoApi({},data){
            return fetchPost('/saas/companyQualification/getCompanyQualificationInfo',data)
        },
        personAuthenticationForSaasApi({},data){// 个人实名认证
            return fetchPost('/saas/customer/personAuthenticationForSaas',data)
        },
        businessAuthenticationSubmitDraftForSaasApi({},data){// 企业实名认证保存
            return fetchPost('/saas/customer/businessAuthenticationSubmitDraftForSaas',data)
        },
        businessAuthenticationForSaasApi({},data){// 企业实名认证提交
            return fetchPost('/saas/customer/businessAuthenticationForSaas',data)
        },
        businessLicenseApi({},data){// 营业执照ocr
            return fetchPost('/saas/ocr/businessLicense',data)
        }
  
    }
}
